import { useScript, useTimeout } from 'libs/hooks';
import { UseScriptProps } from 'libs/hooks/use-script';
import { useState } from 'react';
import ThirdScripts from '../enums/third-scripts.enum';

const useLoadDynatrace = (waitingTime: number) => {
  const [loadDynatrace, setLoadDynatrace] = useState<boolean>(false);

  const props: UseScriptProps = {
    src: `${ThirdScripts.Dynatrace}`,
    checkForExisting: true,
    element: document.head,
    defer: true,
    async: true,
  };

  useTimeout(() => setLoadDynatrace(true), waitingTime);

  useScript({ ...props, runScript: loadDynatrace });
};

export default useLoadDynatrace;
